<template>
  <div class="calendar" style="border: 1px solid #d1dbe5" v-loading.body="loading">
    <div class="calendar-controls middle-aligned" v-bind:style="controlsStyle">
      <el-row :gutter="10">
        <el-col :span="2">
          <div class="grid-content">
            <el-button type="primary" icon="el-icon-d-arrow-left" @click="previousWeek" :disabled="blockPrevious || block"></el-button>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content middle-aligned">
            <b>{{ weekOutput }}</b>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content" style="float:right">
            <el-button type="primary" icon="el-icon-d-arrow-right" @click="nextWeek" :disabled="blockNext || block"></el-button>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="grid-content" >
            <el-button type="primary" @click="today" :disabled="block">Сегодня</el-button>
          </div>
        </el-col>
        <span v-if="isCandidate">
          <el-col :span="2">
            <div class="grid-content middle-aligned" style="min-width:93px;">
              <span>
                Оператор
              </span>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="grid-content">
              <el-select id="operators" v-model="operator" placeholder="Выберите оператора">
                <el-option
                  v-for="item in operators"
                  :key="item.uid"
                  :label="item.fullName"
                  :value="item.uid">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </span>
      </el-row>
    </div>
    <div class="calendar-controls middle-aligned" v-if="showCalendar">
      <el-row :gutter="10">
        <el-col :span="3">
          <div class="grid-content">

          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content middle-aligned calendar-cell">
            <b>
              Понедельник
            </b>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content middle-aligned calendar-cell">
            <b>
              Вторник
            </b>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content middle-aligned calendar-cell">
            <b>
              Среда
            </b>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content middle-aligned calendar-cell">
            <b>
              Четверг
            </b>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content middle-aligned calendar-cell">
            <b>
              Пятница
            </b>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content middle-aligned calendar-cell">
            <b>
              Суббота
            </b>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content middle-aligned calendar-cell">
            <b>Воскресение</b>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="calendar-area" v-if="showCalendar">
      <el-row :gutter="10" v-bind:style="rowHeight" v-for="(row, hourIndex) in hourRows" :key="'hour' + hourIndex">
        <el-col :span="3" class="middle-aligned" style="height: 100%;">
          <span style="text-align:center; height: 100%; padding: 5px 0px 5px 0px;">
            <b style="height:100%; background:#fff;" class="middle-aligned calendar-cell">
              {{row.time}}
            </b>
          </span>
        </el-col>
        <el-col :span="3" class="middle-aligned" style="height:100%" v-for="(day, dayIndex) in row.days" :key="'dayHour' + hourIndex+'_' + dayIndex">
          <span style="height: 100%; padding: 5px 0px 5px 0px;">
            <span v-if="isCandidate" style="height:100%">
              <span v-if="day.disabled && !day.dayEvent" style="height:100%;" class="middle-aligned calendar-cell unavailable">
                Запись не доступна
              </span>
              <el-button v-else-if="day.dayEvent" icon="close" type="danger" style="width:100%; height:100%;" class="button-aligned" @click="cancel(day.date, day.dayEvent)">
                Отмена
              </el-button>
              <el-button v-else icon="check" type="success" style="width:100%; height:100%;" class="button-aligned" @click="enroll(day.date)">
                Запись
              </el-button>
            </span>
            <span v-else style="height:100%">
              <span v-if="day.disabled && !day.dayEvent" style="height:100%;" class="middle-aligned calendar-cell unavailable">
                Нет записи
              </span>
              <span v-else-if="day.dayEvent">
                <el-tooltip placement="top">
                  <div slot="content"> {{ day.summary }} </div>
                  <el-button icon="star-off" type="primary" style="width:100%; height:100%; text-overflow:ellipsis; white-space:nowrap;" class="button-aligned" @click="show(day)">
                    {{ day.summary }}
                  </el-button>
                </el-tooltip>
              </span>
            </span>
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import config from '../../appsettings.js'

  export default {
    name: 'calendar',
    data() {
      return {
        loading: false,
        operators: [],
        hourRows: [],
        operator: null,
        weekIndex: 1,
        isCandidate: false
      }
    },
    watch: {
      operator: function(newOperator) {
        this.fetchData();
      }
    },
    computed: {
      weekStart: function() {
        var date = new Date();
        if(this.weekIndex === 1)
          return this.getMonday(date);
        else if (this.weekIndex === 2) {
          var monday = this.getMonday(date);
          return new Date(monday.setDate(monday.getDate() + 7));
        }
        return null;
      },
      weekEnd: function() {
        var monday = this.weekStart;
        return new Date(monday.setDate(monday.getDate() + 6));
      },
      weekOutput: function() {
        return this.formatPeriodDate(this.weekStart) + '-' + this.formatPeriodDate(this.weekEnd);
      },
      blockNext: function() {
        return this.weekIndex === 2;
      },
      blockPrevious: function() {
        return this.weekIndex === 1;
      },
      block: function() {
        return !this.operator && this.isCandidate;
      },
      rowHeight: function() {
        if(this.showCalendar) {
          return 'height:' + 100 / this.hourRows.length + '%';
        }
        return 'height:100%';
      },
      showCalendar: function() {
        return this.hourRows && this.hourRows.length > 0;
      },
      controlsStyle: function() {
        if(this.showCalendar)
          return 'border-bottom: 1px solid #d1dbe5';
        return 'border-bottom: none';
      }

    },
    methods: {
      getMonday(d) {
        d = new Date(d);
        var day = d.getDay();
        // adjust when day is Sunday
        var diff = d.getDate() - day + (day == 0 ? -6 : 1);
        return new Date(d.setDate(diff));
      },
      formatPeriodDate(d) {
        d = new Date(d);
        var dateFormat = require('dateformat');
        return dateFormat(d, 'dd.mm');
      },
      formatOutputDate(d) {
        d = new Date(d);
        d = new Date(d.getFullYear(), d.getMonth(), d.getDate(),  d.getHours(), d.getMinutes(), d.getSeconds());
        var dateFormat = require('dateformat');
        return dateFormat(d, 'dd.mm.yyyy HH:MM');
      },
      nextWeek() {
        if(!this.blockNext) {
          this.weekIndex++;
          this.fetchData();
        }
      },
      previousWeek() {
        if(!this.blockPrevious) {
          this.weekIndex--;
          this.fetchData();
        }
      },
      today() {
        this.weekIndex = 1;
        this.fetchData();
      },
      enroll(date) {
        if(date && this.operators && this.operator) {
          let result = this.operators.find( a => { return a.uid === this.operator; });
          this.$confirm('Вы действительно хотите записаться на '+this.formatOutputDate(date) +'? Оператор: ' + result.fullName, 'Информация', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Отмена',
            type: 'info'
          }).then(() => {
            let self = this;
            let prefix = config.API_PREFIX;
            this.loading = true;
            this.$gf.getOptions().then(options => {
              options.params = {
              };
              self.$http.post(`${prefix}calendar/enroll`,{ datetime : date, operatorId : this.operator}, options).then(response => {
                this.fetchData();
                Event.$emit('notificationCountChange');
              }).catch(data => {
                this.loading = false;
                self.$gf.checkError(data)
              });
            }).catch(err => {
              this.loading = false;
              this.$gf.catchOptions()
            });

          }).catch(() => {

          });
        }
      },
      cancel(date, dayEvent) {
        if(date && dayEvent && this.operators && this.operator) {
          let result = this.operators.find( a => { return a.uid === this.operator; });
          this.$confirm('Вы действительно хотите отменить запись на '+this.formatOutputDate(date) +'? Оператор: ' + result.fullName, 'Предупреждение', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Отмена',
            type: 'warning'
          }).then(() => {
            let self = this;
            let prefix = config.API_PREFIX;
            this.loading = true;
            this.$gf.getOptions().then(options => {
              options.params = {
              };
              self.$http.put(`${prefix}calendar/cancel`, { eventId : dayEvent }, options).then(response => {
                this.fetchData();
                Event.$emit('notificationCountChange');
              }).catch(data => {
                this.loading = false;
                self.$gf.checkError(data)
              });
            }).catch(err => {
              this.loading = false;
              this.$gf.catchOptions()
            });

          }).catch(() => {

          });
        }
      },
      show(day) {
        //TODO: maybe show
      },
      getOperators() {
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///OPERATORS
          self.$http.get(`${prefix}calendar/operators`, options)
            .then(response => {
              self.operators = response.data;
            })
            .catch(data => {
              self.$gf.checkError(data);
            });
        }).catch(err => {
          this.$gf.catchOptions();
        });
      },
      formatDate(d) {
        if(d) {
          d = new Date(d);
          var dateFormat = require('dateformat');
          return dateFormat(d, 'yyyy-mm-dd');
        }
        return '';
      },
      fetchData() {
        this.loading = true;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          this.fetchCalendar(options);
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      fetchCalendar(options) {
        let self = this;
        let prefix = config.API_PREFIX;
        let ws = new Date();
        if(this.weekIndex === 1)
          ws = this.getMonday(ws);
        else if (this.weekIndex === 2) {
          var monday = this.getMonday(ws);
          ws = new Date(monday.setDate(monday.getDate() + 7));
        }
        ws = this.formatDate(ws);
        let op = this.operator;
        let candidateGet = op ? (`${prefix}calendar/?startDate=` + ws + `&operatorId=` + op) : null;
        let operatorGet = `${prefix}calendar/queue/?startDate=` + ws;
        let get = this.isCandidate ? candidateGet : operatorGet;
        if(get) {
          ///CALENDAR
          self.$http.get(get, options)
            .then(response => {
              self.hourRows = response.data;
              this.loading = false;
            })
            .catch(data => {
              self.$gf.checkError(data);
              this.loading = false;
            });
        } else {
          this.loading = false;
        }
      },
      checkIsCandidate() {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          self.$http.get(`${prefix}calendar/candidate`, options)
            .then(response => {
              this.isCandidate = response.data;
              this.fetchCalendar(options);
            })
            .catch(data => {
              self.$gf.checkError(data);
              this.loading = false;
            });
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      }
    },
    created: function () {
      this.checkIsCandidate();
      this.getOperators();
    }
  }
</script>

<style scoped>
  .calendar {
    height: calc(100% - 20px);
    background: #eef1f6;
  }
  .calendar-controls {
    height: 50px;
    width: 100%;
    background: #eef1f6;
    padding: 0px 10px 0px 10px;
  }
  .calendar-cell {
    background: #fff;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #d1dbe5;
  }
  .calendar-area {
    height: calc(100% - 120px);
    width: 100%;
    background: #eef1f6;
    padding: 0px 10px 0px 10px;
  }
  .middle-aligned {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .button-aligned {
    padding: 0px !important;
  }
  .grid-content {
    min-height: 36px;
  }
  .unavailable {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/personalarea/calendar.vue